import type { api } from "~/utils/api";

type ProjectUtils = ReturnType<typeof api.useUtils>["project"];
// predicate/queryKey are typed per-procedure, so Omit them to keep a shape assignable to both invalidates.
type InvalidateFilters = Omit<
  NonNullable<Parameters<ProjectUtils["getSearchResults"]["invalidate"]>[1]>,
  "predicate" | "queryKey"
>;

// getGroupedSearchCounts is a separate project-derived cache: without this, grouped-view header
// counts stay stale after a mutation even though the rows underneath already refreshed.
export function invalidateProjectSearch(project: ProjectUtils, filters?: InvalidateFilters): Promise<unknown> {
  return Promise.all([
    project.getSearchResults.invalidate(undefined, filters),
    project.getGroupedSearchCounts.invalidate(undefined, filters),
  ]);
}
